import { JoinBanner } from '@presentation/components';
import type { FC } from 'react';
import type { JoinLandingPageProps } from '..';
import * as Styled from './styled';

export * from './types';

export const JoinLandingPage: FC<JoinLandingPageProps> = (props) => {
  const { joinBanner } = props;
  return (
    <Styled.Wrapper>
      <JoinBanner {...joinBanner} />
    </Styled.Wrapper>
  );
};
